import { sleep } from './retry';

export const DEFAULT_POST_REPORT_ACTION_DELAY_MS = 2500;

let postReportActionDelayMs = DEFAULT_POST_REPORT_ACTION_DELAY_MS;

/**
 * Overrides the pause before a reported mail is moved or deleted. Integration tests set it to 0
 * so the full report flow runs on real timers without waiting.
 */
export const setPostReportActionDelay = (ms: number) => {
  postReportActionDelayMs = ms;
};

/**
 * Keeps the success toasts visible before the mail is moved or deleted, which removes it from
 * the list and closes the task pane.
 */
export const waitBeforePostReportAction = () => sleep(postReportActionDelayMs);
